export default (payload, type = 'PATCH') => ({
  type,
  payload,
});
